import React, { useState, useEffect } from "react";
import GetUsers from "../api/GetUsers";
import UserComponent from "../components/UserComponent";

function Users() {
  const [users, setUsers] = useState([]);
  const [filterUser, setFilterUser] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterStatus, setFilterStatus] = useState(0);

  // in using effect set filter Client = client return from context
  useEffect(() => {
    const setUser = async () => {
      let userData = await GetUsers();
      userData = userData.filter((user) => user.username !== "admin");
      setUsers(userData);
      setFilterUser(userData);
    };
    setUser();
  }, []);

  const handlerSearchForm = (e) => {
    e.preventDefault();
    let filtered = [];

    // filter using status
    if (filterStatus !== 0) {
      filtered = users.filter((user) => user.status === filterStatus);
    } else {
      filtered = users;
    }

    // filter using filter name
    if (filterName) {
      filtered = filtered.filter((user) => user.name.toLowerCase().includes(filterName));
    }
    //  filter user
    setFilterUser(filtered);
  };

  return (
    <>
      <section className="body-font text-gray-600">
        <div className="container mx-auto py-8">
          <div className="mb-8 flex flex-col lg:flex-row-reverse justify-between items-center md:border-b pb-4">
            <h2 className="text-right text-2xl font-bold p-4">قائمة المستخدمين</h2>
            <form
              className="flex flex-col p-8 items-center lg:flex-row-reverse md:items-center"
              onSubmit={handlerSearchForm}
            >
              <div className="mb-2 mx-2 flex flex-row-reverse items-center">
                <label className="p-2 mx-4">بحث بواسطة إسم المستخدم</label>
                <input
                  type="text"
                  className="py-2 px-2 bg-white border rounded-lg"
                  dir="rtl"
                  placeholder="بحث بواسطة الإسم"
                  value={filterName}
                  onChange={(e) => {
                    setFilterName(e.target.value);
                  }}
                />
              </div>
              <div className="mb-2 mx-4 flex flex-row-reverse items-center">
                <label className="p-2 mx-4">حالة المستخدم</label>
                <select
                  className=" p-2 border rounded-lg"
                  dir="rtl"
                  value={filterStatus}
                  onChange={(e) => {
                    setFilterStatus(Number(e.target.value));
                  }}
                >
                  <option value="0" spellCheck="">
                    غير محدد
                  </option>
                  <option value="3">مستخدم جديد</option>
                  <option value="2">مستخدم غير فعال</option>
                  <option value="1">مستخدم فعال</option>
                </select>
              </div>
              <div className="mb-2  flex flex-row-reverse items-center">
                <button type="submit" className="py-2 px-4 bg-blue-500 rounded text-mld text-white">
                  بحث
                </button>
              </div>
            </form>
          </div>
          <div className="-m-4 flex flex-wrap flex-row-reverse">
            <div className="container mx-auto border-t pb-8">
              <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-center">حالة المستخدم</th>
                    <th className="px-6 py-3 text-center">موقع المستخدم</th>
                    <th className="px-6 py-3 text-center">كلمة المرور </th>
                    <th className="px-6 py-3 text-center">الإسم </th>
                    <th className="px-6 py-3 text-center">إسم المستخدم</th>
                  </tr>
                </thead>
                <tbody id="table_list_item">
                  {filterUser ? (
                    filterUser.map((user) => {
                      return <UserComponent user={user} key={user.id} />;
                    })
                  ) : (
                    <tr>
                      <th className="px-6 py-3 text-center"> -</th>
                      <th className="px-6 py-3 text-center">- </th>
                      <th className="px-6 py-3 text-center">- </th>
                      <th className="px-6 py-3 text-center">- </th>
                      <th className="px-6 py-3 text-center">- </th>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Users;
